
import util from '../../util/Util';
import {DateType, getQuoteAcceptStatus, getCustomerTypes, LoadCategories, getQuoteAcceptStatusClass, getJobStatusClass, getJobStatus} from '../../util/Enum';
import Cars from '~/components/svgs/quotes/Cars.vue';
import Agriculture from '~/components/svgs/quotes/Agriculture.vue';
import Boats from '~/components/svgs/quotes/Boats.vue';
import Containersportablebuildins from '~/components/svgs/quotes/Containersportablebuildins.vue';
import Generalhaulage from '~/components/svgs/quotes/Generalhaulage.vue';
import Heavyoversizedhaulage from '~/components/svgs/quotes/Heavyoversizedhaulage.vue';
import Householdfurniture from '~/components/svgs/quotes/Householdfurniture.vue';
import Machinerytransport from '~/components/svgs/quotes/Machinerytransport.vue';
import Motorcycles from '~/components/svgs/quotes/Motorcycles.vue';
import Other from '~/components/svgs/quotes/Other.vue';
import Person from '~/components/svgs/Person.vue';
import Othervehicles from '~/components/svgs/quotes/Othervehicles.vue';
import Palletspackages from '~/components/svgs/quotes/Palletspackages.vue';
import Petslivestock from '~/components/svgs/quotes/Petslivestock.vue';
import Refrigerated from '~/components/svgs/quotes/Refrigerated.vue';
import Rvcaravanstrailers from '~/components/svgs/quotes/Rvcaravanstrailers.vue';
import Trucktrailers from '~/components/svgs/quotes/Trucktrailers.vue';
import Wasterecycling from '~/components/svgs/quotes/Wasterecycling.vue';
import UteAndVanCargo from '~/components/svgs/quotes/UteAndVanCargo.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ReviewModal from '~/components/modal/ReviewModal';
import SubmitQuoteModal from '~/components/modal/SubmitQuoteModal';
import {SHIPPER, CARRIER} from '../../util/constants';
import ProfilePop from '../ProfilePop.vue';
import moment from 'moment';

export default {
  components: {
    Cars,
    Agriculture,
    Boats,
    Containersportablebuildins,
    Generalhaulage,
    Heavyoversizedhaulage,
    Householdfurniture,
    Machinerytransport,
    Motorcycles,
    Other,
    Person,
    Othervehicles,
    Palletspackages,
    Petslivestock,
    Refrigerated,
    Rvcaravanstrailers,
    Trucktrailers,
    UteAndVanCargo,
    Wasterecycling,
    ReviewModal,
    SubmitQuoteModal,
    ProfilePop
  },
  mixins: [validationMixin],
  props: {
    load: {
      type: Object,
      default: ()=>{}
    },
    isShipper: {
      type: Boolean,
      default: false
    },
    recordType : {
      type: String,
      default: 'load'
    },
    page: {
      type: Number,
      default: 0
    },
    queryParams: {
      type: Object,
      default: ()=>{}
    },
  },
  data() {
    return {
      getQuoteAcceptStatus,
      getQuoteAcceptStatusClass,
      getJobStatusClass,
      getJobStatus,
      util,
      DateType,
      getCustomerTypes,
      LoadCategories,
      loadData: this.load.load,
      isModalVisible: false,
      loadExpireDate: null,
      loadDetails: this.load.details,
      isReviewModalVisible: false,
      isQuoteModalVisible: false,
      selectedQuote: null,
      activeTab:0,
      SHIPPER,
      CARRIER,
      popoverShow:false,
      isFavourite: false
     };
  },
  validations: {
    loadExpireDate: {
      required
    }
  },
  computed:{
    user() {
      return this.$store.state.user
    }
  },
  watch: {
    'load.load': {
      handler() {
        this.isFavourite = this.load.isFav || false
      },
      deep: true,
    },
  },
  mounted(){
    this.isFavourite = this.load.isFav || false

  },
  methods: {
    profPop(e){
      e.stopPropagation();
      this.popoverShow =!this.popoverShow;
    },
    validateDetailsState() {
      const { $dirty, $error } = this.$v.loadExpireDate;
      return $dirty ? !$error : null;
    },
    isNew() {
      // Last 48 hrs
      const yesterday = moment().subtract(1, 'day')
      const createdOn = new Date(this.loadData.createdOn)
      const timeDiff = Math.ceil(util.getDurationInDays(createdOn, yesterday))
      return (timeDiff <=1);
    },
    checkIsFavourite() {
      const data = {
        loadId: this.loadData.id,
        user: this.user
      }
        this.$store.dispatch('favourites/checkIsFavourite', data).then((res) => {
        if (res.isSuccess) {
          if(res.result !==null){
            this.isFavourite = res.result
          }
        }
      });
    },
    toggleFavourites(e, value) {
      e.stopPropagation();
      const data = {
        loadId: this.loadData.id,
        user: this.user
      }
      if(value){
        this.$store.dispatch('favourites/addToFavourites', data).then((res) => {
        if (res.isSuccess) {
            if(this.recordType ==='loads'){
              this.checkIsFavourite();
            }
            else {
              this.$emit('reload-fav');
            }
            this.$toast.success('Successfully Saved the Load').goAway(3000)
        } else {
            this.$toast.error('Failed Saving the Load - Contact support@utransport.com.au').goAway(5000)
          }
      });
      }
      else{
        this.$store.dispatch('favourites/removeFromFavourites', data).then((res) => {
        if (res.isSuccess) {
          if(this.recordType ==='loads'){
              this.checkIsFavourite();
            }
          else {
            this.$emit('reload-fav');
          }
            this.$toast.success('Successfully Removed from Saved Loads').goAway(3000)
        } else {
            this.$toast.error('Failed Removing from the Saved Loads - Contact support@utransport.com.au').goAway(5000)
          }
      });
      }
    },
    getAddress(data){
      if(data) {
      return ( ((data.suburb && data.suburb) + ( data.state && (', ' + data.state))+ (data.postCode && (', ' + data.postCode))).toUpperCase());
      }
      else {
        return '-'
      }
    },
    itemClicked(){
 
        this.redirectToDetails(0)
      
    },
    showReviewModal(e) {
      e.stopPropagation();
      this.isReviewModalVisible = true
    },
    closeReviewModal() {
      this.isReviewModalVisible = false
    },
    updatejobsList() {
      this.$emit('reload-loads');
    },
    showQuoteModal(e) {
      e.stopPropagation();
      const data = {
        loadId: this.loadData.id,
        quoteId: this.loadData.quoteId,
        user: this.user
      }
      this.$store.dispatch('quote/getQuoteData', data).then((res) => {
        if (res.isSuccess) {
          this.selectedQuote = res.result
          this.isQuoteModalVisible = true
        }
      });
    },
    updateMyQuotesList() {
      this.$emit('reload-loads');
    },
    closeQuoteModal() {
      this.selectedQuote = null
      this.isQuoteModalVisible = false;
    },
    redirctToQuote(e){
      e.stopPropagation();
      this.redirectToDetails(1)
    },
    redirectToDetails(tab=0){
      // re-direct to submit quote
      if(tab == 1){
        this.$router.push({path:`/loads-board/${this.loadData.id}`, query: {...this.queryParams, activeTab: tab, 'submitQuote': true, page : this.page}} )
      }else{
        this.$router.push({path:`/loads-board/${this.loadData.id}`, query: {...this.queryParams, activeTab: tab, page: this.page}} )
      }
    },
    dateDisabled(ymd, date) {
      let today = new Date();
      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      if (date.setHours(0, 0, 0, 0) <= yesterday.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    },
    relistPopup(e) {
      e.stopPropagation();
      this.isModalVisible = true
    },
    publishLoad(e) {
      e.stopPropagation();
      const data = {
        loadId: this.loadData.id,
        user: this.user
      }
      this.$store.dispatch('loads/publishLoad', data).then((res) => {
        if (res.isSuccess) {
            this.$toast.success('Listing Successfully Published').goAway(3000)
            this.isLoading = false
        } else {
            this.$toast.error('Failed to Publish Listing - Contact support@utransport.com.au').goAway(5000)
            this.isLoading = false
          }
      });
    },
    // relist expired load
    relistLoad(event) {
      event.preventDefault()
      this.$v.loadExpireDate.$touch();
      if (this.$v.loadExpireDate.$anyError) {
        return;
      } else {
        const data = {
          data: {
            loadId: this.loadData.id,
            expiryDate: this.loadExpireDate
          },
          user: this.user
        }
        this.$store.dispatch('loads/relistLoad', data).then((res) => {
          if (res.isSuccess) {
            this.$emit('reload-loads');
            this.$toast.success('Load Successfully Relisted').goAway(3000)
          } else {
              this.$toast.error('Failed to Relist - Contact support@utransport.com.au	').goAway(5000)
          }
          this.isModalVisible = false
        });
      }
    },
    confirmCompleteJob(e) {
      e.stopPropagation();
      const msgBody = 'Are you sure, you want to complete this job?'
      this.$bvModal.msgBoxConfirm(msgBody, {
        title: 'Complete job - '.concat(this.loadData.description),
        cancelVariant:'primary',
        okVariant:'secondary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        hideHeaderClose: false,
        centered: true,
        contentClass: 'quote-modal',
        bodyClass: 'form-componant'
      })
      .then(value => {
        if (value){
          this.completeJob()
        }
      })
      .catch(() => {
        this.$toast.error('Failed to mark job complete - Contact support@utransport.com.au').goAway(5000)
        this.isLoading = false
      })
    },
    completeJob() {
      this.isLoading = true
      const data = {
        jobId: this.loadData.jobId,
        user: this.user
      }
      this.$store.dispatch('jobs/completeJob', data).then((res) => {
        if (res.isSuccess) {
            this.$toast.success('Successfully Completed').goAway(3000)
            this.isLoading = false
            this.$emit('reload-loads');
        } else {
            this.$toast.error('Failed to Mark Job Complete - Contact support@utransport.com.au').goAway(5000)
            this.isLoading = false
          }
      });
    },
  }
}
